import { render } from "./UpdateVolume.vue?vue&type=template&id=ad049ce4&scoped=true"
import script from "./UpdateVolume.vue?vue&type=script&lang=js"
export * from "./UpdateVolume.vue?vue&type=script&lang=js"

import "./UpdateVolume.vue?vue&type=style&index=0&id=ad049ce4&lang=scss&scoped=true"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad049ce4"]])

export default __exports__